import { create } from "zustand";
import { api } from "@/lib/api";

export const useAuth = create((set) => ({
  user: null,
  loading: true,
  async init() {
    const t = localStorage.getItem("nakama_token");
    if (!t) {
      set({ loading: false });
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      set({ user: data, loading: false });
    } catch {
      localStorage.removeItem("nakama_token");
      set({ user: null, loading: false });
    }
  },
  async login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nakama_token", data.access_token);
    set({ user: data.user });
    return data.user;
  },
  logout() {
    localStorage.removeItem("nakama_token");
    set({ user: null });
  },
  setUser(u) {
    set({ user: u });
  },
}));
